import { Avatar, Box, Group, Popover, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { IconSelector } from '@tabler/icons-react';
import { useState } from 'react';

import SwitchAccount, { getAccountAvatar } from './SwitchAccount';

/**
 * Header control showing the company you're signed in to, with a popover to switch accounts.
 * Hidden unless there is more than one account to choose from.
 */
const AccountSwitcher = ({ account, accounts = [], user, opened = false, onChange, onSwitch }) => {
    const theme = useMantineTheme();
    const [hovered, setHovered] = useState(false);

    if (!account || accounts.length <= 1) return null;

    const { initials, color } = getAccountAvatar(account);
    const isDark = theme.colorScheme === 'dark';

    const content = (
        <Group spacing='xs' noWrap>
            <Avatar size='sm' radius='sm' color={color} variant='filled'>
                {initials}
            </Avatar>
            <Box style={{ maxWidth: 180 }}>
                <Text size='sm' weight={500} lineClamp={1}>
                    {account.name}
                </Text>
            </Box>
            <IconSelector size={16} color={isDark ? theme.colors.dark[2] : theme.colors.gray[6]} />
        </Group>
    );

    const isActive = opened || hovered;

    return (
        <Popover opened={opened} onChange={onChange} width={320} position='bottom-end' shadow='md' withArrow trapFocus returnFocus>
            <Popover.Target>
                <UnstyledButton
                    onClick={() => onChange(!opened)}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    title={account.name}
                    aria-label='Switch account'
                    style={{
                        padding: `6px ${theme.spacing.xs}px`,
                        borderRadius: theme.radius.sm,
                        border: `1px solid ${isDark ? theme.colors.dark[4] : theme.colors.gray[3]}`,
                        backgroundColor: isActive ? (isDark ? theme.colors.dark[6] : theme.colors.gray[0]) : 'transparent',
                        color: isDark ? theme.colors.dark[0] : theme.black,
                    }}>
                    {content}
                </UnstyledButton>
            </Popover.Target>
            <Popover.Dropdown p={0}>
                <SwitchAccount accounts={accounts} currentAccount={account} user={user} onSwitch={onSwitch} />
            </Popover.Dropdown>
        </Popover>
    );
};

export default AccountSwitcher;
